module.exports = __webpack_public_path__ + "img/photo3.42305c18.jpeg";